exports.tokens = {
  "ButtonPrimaryActiveFillColor": "linear-gradient(206deg, #373ae5 0%, #292cb7 52.08%)",
  "ButtonPrimaryActiveTextColor": "#ffffff",
  "ButtonPrimaryActiveIconColor": "#ffffff",
  "ButtonPrimaryActiveBorderColor": "#00000000",
  "ButtonPrimaryHoverFillColor": "#373ae5",
  "ButtonPrimaryHoverTextColor": "#ffffff",
  "ButtonPrimaryHoverIconColor": "#ffffff",
  "ButtonPrimaryHoverBorderColor": "#00000000",
  "ButtonPrimaryPressedFillColor": "#1b1d88",
  "ButtonPrimaryPressedTextColor": "#ffffff",
  "ButtonPrimaryPressedIconColor": "#ffffff",
  "ButtonPrimaryPressedBorderColor": "#00000000",
  "ButtonPrimaryDisabledFillColor": "#747474",
  "ButtonPrimaryDisabledTextColor": "#ffffff",
  "ButtonPrimaryDisabledIconColor": "#ffffff",
  "ButtonPrimaryDisabledBorderColor": "#00000000",
  "ButtonSecondaryActiveBorderColor": "#00012b",
  "ButtonSecondaryActiveTextColor": "#00012b",
  "ButtonSecondaryActiveIconColor": "#00012b",
  "ButtonSecondaryActiveFillColor": "#00000000",
  "ButtonSecondaryHoverBorderColor": "#00012b",
  "ButtonSecondaryHoverTextColor": "#00012b",
  "ButtonSecondaryHoverIconColor": "#00012b",
  "ButtonSecondaryHoverFillColor": "#00000000",
  "ButtonSecondaryPressedFillColor": "#00012b",
  "ButtonSecondaryPressedTextColor": "#ffffff",
  "ButtonSecondaryPressedIconColor": "#ffffff",
  "ButtonSecondaryPressedBorderColor": "#00000000",
  "ButtonSecondaryDisabledBorderColor": "#747474",
  "ButtonSecondaryDisabledTextColor": "#747474",
  "ButtonSecondaryDisabledIconColor": "#747474",
  "ButtonSecondaryDisabledFillColor": "#00000000",
  "ButtonTertiaryActiveTextColor": "#373ae5",
  "ButtonTertiaryActiveIconColor": "#373ae5",
  "ButtonTertiaryActiveFillColor": "#00000000",
  "ButtonTertiaryActiveBorderColor": "#00000000",
  "ButtonTertiaryHoverFillColor": "#f4f3fc",
  "ButtonTertiaryHoverTextColor": "#373ae5",
  "ButtonTertiaryHoverIconColor": "#373ae5",
  "ButtonTertiaryHoverBorderColor": "#00000000",
  "ButtonTertiaryPressedFillColor": "#dedefb",
  "ButtonTertiaryPressedTextColor": "#373ae5",
  "ButtonTertiaryPressedBorderColor": "#00000000",
  "ButtonTertiaryPressedIconColor": "#373ae5",
  "ButtonTertiaryDisabledTextColor": "#747474",
  "ButtonTertiaryDisabledIconColor": "#747474",
  "ButtonTertiaryDisabledFillColor": "#00000000",
  "ButtonTertiaryDisabledBorderColor": "#00000000",
  "ButtonLHeight": "56px",
  "ButtonLIconSize": "24px",
  "ButtonLPaddingLeft": "16",
  "ButtonLPaddingRight": "16",
  "ButtonLPaddingTop": "16",
  "ButtonLPaddingBottom": "16",
  "ButtonLBorderRadius": "8",
  "ButtonLFocusselectorBorderRadius": "10",
  "ButtonLTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ButtonLLoaderIconSize": "24px",
  "ButtonSHeight": "40px",
  "ButtonSIconSize": "20px",
  "ButtonSPaddingLeft": "16",
  "ButtonSPaddingRight": "16",
  "ButtonSBorderRadius": "6",
  "ButtonSFocusselectorBorderRadius": "8",
  "ButtonSTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ButtonSLoaderIconSize": "20px",
  "ButtonBorderWidth": "1",
  "ButtonFocusselectorBorderWidth": "1.5",
  "ButtonFocusselectorBorderColor": "#292cb7",
  "ProgressSmallDisabledTrackFillColor": "#a2a2a2",
  "ProgressSmallDisabledProgressIndicatorFillColor": "#ffffff",
  "ProgressSmallDefaultTrackFillColor": "#d1d1d1",
  "ProgressSmallDefaultProgressIndicatorFillColor": "#171717",
  "ProgressSmallTrackWidth": "1",
  "ProgressSmallIndicatorWidth": "1",
  "ProgressSmallPrimaryInactiveFillColor": "#a2a2a2",
  "ProgressSmallPrimaryActiveFillColor": "#ffffff",
  "ProgressSmallSecondaryInactiveFillColor": "#d1d1d1",
  "ProgressSmallSecondaryActiveFillColor": "#171717",
  "ProgressSmallTertiaryInactiveFillColor": "#d1d1d1",
  "ProgressSmallTertiaryActiveFillColor": "#171717",
  "ProgressSmallCircleSize": "20",
  "ProgressTrackFillColor": "#d1d1d1",
  "ProgressTrackBorderColor": "#00000000",
  "ProgressTrackBorderRadius": "8",
  "ProgressTrackBorderWidth": "1",
  "ProgressIndicatorFillColor": "#373ae5",
  "ProgressIndicatorBorderColor": "#00000000",
  "ProgressIndicatorBorderRadius": "8",
  "ProgressIndicatorBorderWidth": "1",
  "ProgressLabelTextColor": "#00012b",
  "ProgressLabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ProgressSupportingtextTextColor": "#5d5d5d",
  "ProgressSupportingtextTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ProgressLinearTrackHeight": "8px",
  "ProgressLinearIndicatorHeight": "8px",
  "ProgressLinearBufferHeight": "8px",
  "ProgressCircularTrackWidth": "8px",
  "ProgressCircularIndicatorWidth": "8px",
  "ProgressCircularCircleSize": "48px",
  "ProgressVerticalPadding": "8",
  "ProgressBufferBorderWidth": "1",
  "ProgressBufferColor": "#faf9f5",
  "CheckboxSIconSize": "18px",
  "CheckboxSHeight": "24px",
  "CheckboxSBorderRadius": "4",
  "CheckboxSFocusselectorBorderRadius": "6",
  "CheckboxSWidth": "24px",
  "CheckboxLIconSize": "24px",
  "CheckboxLHeight": "32px",
  "CheckboxLBorderRadius": "8",
  "CheckboxLFocusselectorBorderRadius": "10",
  "CheckboxLWidth": "32px",
  "CheckboxActiveFalseOutlineColor": "#747474",
  "CheckboxActiveFalseFillColor": "#00000000",
  "CheckboxActiveTrueFillColor": "#373ae5",
  "CheckboxActiveTrueIconColor": "#ffffff",
  "CheckboxActiveTrueOutlineColor": "#00000000",
  "CheckboxActiveLabelColor": "#00012b",
  "CheckboxHoverFalseOutlineColor": "#00012b",
  "CheckboxHoverFalseFillColor": "#00000000",
  "CheckboxHoverTrueOutlineColor": "#00012b",
  "CheckboxHoverTrueFillColor": "#373ae5",
  "CheckboxHoverTrueIconColor": "#ffffff",
  "CheckboxHoverLabelColor": "#00012b",
  "CheckboxPressedTrueOutlineColor": "#00012b",
  "CheckboxPressedTrueFillColor": "#373ae5",
  "CheckboxPressedTrueIconColor": "#ffffff",
  "CheckboxDisabledFalseOutlineColor": "#a2a2a2",
  "CheckboxDisabledFalseFillColor": "#00000000",
  "CheckboxDisabledTrueFillColor": "#a2a2a2",
  "CheckboxDisabledTrueIconColor": "#ffffff",
  "CheckboxDisabledTrueOutlineColor": "#00000000",
  "CheckboxDisabledLabelColor": "#a2a2a2",
  "CheckboxFocusselectorBorderColor": "#292cb7",
  "CheckboxFocusselectorBorderWidth": "1.5",
  "CheckboxFocusselectorPadding": "2",
  "CheckboxLabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CheckboxLabelFocusselectorPadding": "4",
  "CheckboxLoadingFillColor": "#a2a2a2",
  "RadiobuttonSHeight": "24px",
  "RadiobuttonSBorderRadius": "100",
  "RadiobuttonSWidth": "24px",
  "RadiobuttonFocusselectorBorderRadius": "100",
  "RadiobuttonFocusselectorBorderWidth": "1.5",
  "RadiobuttonFocusselectorBorderColor": "#292cb7",
  "RadiobuttonFocusselectorPadding": "2",
  "RadiobuttonBorderWidth": "1",
  "RadiobuttonLHeight": "32px",
  "RadiobuttonLBorderRadius": "100",
  "RadiobuttonLWidth": "32px",
  "RadiobuttonActiveFalseOutlineColor": "#747474",
  "RadiobuttonActiveFalseFillColor": "#00000000",
  "RadiobuttonActiveTrueFillColor": "#373ae5",
  "RadiobuttonActiveTrueOutlineColor": "#747474",
  "RadiobuttonActiveLabelColor": "#00012b",
  "RadiobuttonHoverFalseOutlineColor": "#00012b",
  "RadiobuttonHoverFalseFillColor": "#00000000",
  "RadiobuttonHoverTrueOutlineColor": "#00012b",
  "RadiobuttonHoverTrueFillColor": "#373ae5",
  "RadiobuttonHoverLabelColor": "#00012b",
  "RadiobuttonPressedTrueOutlineColor": "#00012b",
  "RadiobuttonPressedTrueFillColor": "#373ae5",
  "RadiobuttonDisabledTrueOutlineColor": "#747474",
  "RadiobuttonDisabledTrueFillColor": "#747474",
  "RadiobuttonDisabledFalseOutlineColor": "#747474",
  "RadiobuttonDisabledFalseFillColor": "#00000000",
  "RadiobuttonDisabledLabelColor": "#a2a2a2",
  "RadiobuttonLabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "RadiobuttonLabelFocusselectorBorderRadius": "10",
  "RadiobuttonLabelFocusselectorPadding": "4",
  "TextlinkSActive": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkSIconSize": "18px",
  "TextlinkSHover": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkSFocused": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkSPressed": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkSDisabled": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkLActive": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkLIconSize": "20px",
  "TextlinkLHover": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkLFocused": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkLPressed": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkLDisabled": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TextlinkActiveTextColor": "#00012b",
  "TextlinkActiveIconColor": "#00012b",
  "TextlinkHoverTextColor": "#373ae5",
  "TextlinkHoverIconColor": "#373ae5",
  "TextlinkPressedTextColor": "#373ae5",
  "TextlinkPressedIconColor": "#373ae5",
  "TextlinkDisabledTextColor": "#747474",
  "TextlinkDisabledIconColor": "#747474",
  "TextlinkFocusselectorBorderColor": "#292cb7",
  "TextlinkFocusselectorBorderWidth": "1.5",
  "TextlinkFocusselectorBorderRadius": "6",
  "ChipActiveFillColor": "#00000000",
  "ChipActiveBorderColor": "#00012b",
  "ChipActiveTextColor": "#00012b",
  "ChipActiveIconColor": "#00012b",
  "ChipActiveBorderWidth": "1",
  "ChipPressedFillColor": "#f4f3fc",
  "ChipPressedBorderColor": "#373ae5",
  "ChipPressedTextColor": "#00012b",
  "ChipPressedIconColor": "#00012b",
  "ChipPressedBorderWidth": "1",
  "ChipHoverFillColor": "#00000000",
  "ChipHoverBorderColor": "#00012b",
  "ChipHoverTextColor": "#00012b",
  "ChipHoverBorderWidth": "2",
  "ChipHoverIconColor": "#00012b",
  "ChipDisabledFillColor": "#00000000",
  "ChipDisabledBorderColor": "#747474",
  "ChipDisabledTextColor": "#747474",
  "ChipDisabledIconColor": "#747474",
  "ChipDisabledBorderWidth": "1",
  "ChipFocusselectorBorderColor": "#292cb7",
  "ChipFocusselectorBorderWidth": "1.5",
  "ChipFocusselectorBorderRadius": "100",
  "ChipSTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ChipSHeight": "40px",
  "ChipSPaddingLeft": "16",
  "ChipSPaddingRight": "16",
  "ChipSIconSize": "20px",
  "ChipSBorderRadius": "100",
  "ChipLTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ChipLHeight": "48px",
  "ChipLPaddingLeft": "16",
  "ChipLPaddingRight": "16",
  "ChipLIconSize": "24px",
  "ChipLBorderRadius": "100",
  "ToggleHeight": "32px",
  "ToggleWidth": "52",
  "ToggleBorderRadius": "100",
  "ToggleFocusselectorBorderRadius": "100",
  "ToggleFocusselectorBorderColor": "#292cb7",
  "ToggleFocusselectorBorderWidth": "1.5",
  "ToggleFocusselectorPadding": "2",
  "ToggleActiveFalseTrackColor": "#747474",
  "ToggleActiveFalseHandleColor": "#ffffff",
  "ToggleActiveTrueTrackColor": "#373ae5",
  "ToggleActiveTrueHandleColor": "#ffffff",
  "ToggleActiveTrueIconColor": "#373ae5",
  "ToggleActiveLabelColor": "#00012b",
  "ToggleDisabledFalseTrackColor": "#a2a2a2",
  "ToggleDisabledFalseHandleColor": "#ffffff",
  "ToggleDisabledTrueTrackColor": "#a2a2a2",
  "ToggleDisabledTrueHandleColor": "#ffffff",
  "ToggleDisabledTrueIconColor": "#a2a2a2",
  "ToggleDisabledLabelColor": "#a2a2a2",
  "ToggleIconSize": "20px",
  "ToggleLabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "fontSize": "16",
    "lineHeight": "135%",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "ToggleLabelFocusselectorBorderRadius": "10",
  "ToggleLabelFocusselectorPadding": "4",
  "CardcontainerExplicitOutlineColor": "#d1d1d1",
  "CardcontainerExplicitFillColor": "#ffffff",
  "CardcontainerImplicitOutlineColor": "#00000000",
  "CardcontainerImplicitFillColor": "#00000000",
  "CardcontainerFocusselectorBorderColor": "#292cb7",
  "CardcontainerFocusselectorBorderRadius": "8",
  "CardcontainerFocusselectorBorderWidth": "1.5",
  "CardcontainerBorderRadius": "8",
  "CardcontainerBorderWidth": "1",
  "TextinputHeight": "56px",
  "TextinputIconSize": "24px",
  "TextinputPaddingLeft": "16",
  "TextinputPaddingRight": "16",
  "TextinputDefaultTopBorderRadius": "8",
  "TextinputDefaultBottomBorderRadius": "0",
  "TextinputFocusedBorderRadius": "8",
  "TextinputErrorBorderRadius": "8",
  "TextinputBorderWidth": "0.5",
  "TextinputInputfieldActiveFillColor": "#ffffff",
  "TextinputInputfieldActiveBorderColor": "#5d5d5d",
  "TextinputInputfieldFocusedFillColor": "#ffffff",
  "TextinputInputfieldFocusedBorderColor": "#373ae5",
  "TextinputInputfieldFocusedElevation": {
    "x": "2",
    "y": "2",
    "blur": "8",
    "spread": "0",
    "color": "#373ae51a",
    "type": "dropShadow"
  },
  "TextinputInputfieldDisabledFillColor": "#f5f5f5",
  "TextinputInputfieldDisabledBorderColor": "#5d5d5d",
  "TextinputInputfieldDisabledElevation": {
    "x": "0",
    "y": "0",
    "blur": "0",
    "spread": "0",
    "color": "#00000000",
    "type": "innerShadow"
  },
  "TextinputInputfieldErrorFillColor": "#ffffff",
  "TextinputInputfieldErrorBorderColor": "#C60600",
  "TextinputInputfieldErrorElevation": {
    "x": "0",
    "y": "0",
    "blur": "0",
    "spread": "0",
    "color": "#00000000",
    "type": "innerShadow"
  },
  "TextinputInputfieldDefaultElevation": {
    "x": "0",
    "y": "0",
    "blur": "0",
    "spread": "0",
    "color": "#00000000",
    "type": "innerShadow"
  },
  "TextinputInputtextActive": "#00012b",
  "TextinputInputtextDisabled": "#747474",
  "TextinputInputtextTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TextinputRestinglabelActive": "#5d5d5d",
  "TextinputRestinglabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TextinputFloatinglabelActive": "#5d5d5d",
  "TextinputFloatinglabelFocused": "#373ae5",
  "TextinputFloatinglabelDisabled": "#747474",
  "TextinputFloatinglabelError": "#C60600",
  "TextinputFloatinglabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TextinputIconActive": "#00012b",
  "TextinputIconFocused": "#373ae5",
  "TextinputIconDisabled": "#747474",
  "TextinputIconError": "#C60600",
  "TextinputHintActiveTextColor": "#00012b",
  "TextinputHintErrorTextColor": "#C60600",
  "TextinputHintTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TextinputHintDisabledTextColor": "#747474",
  "TextinputDividerLineColor": "#d1d1d1",
  "TextinputDividerHeight": "32px",
  "TextinputDividerBorderWidth": "0.5",
  "TextinputFocusselectorBorderWidth": "1.5",
  "TextinputCreditcardDisabledIconOpacity": "50%",
  "AlertTextColor": "#00012b",
  "AlertIconColor": "#00012b",
  "AlertCloseIconColor": "#00012b",
  "AlertErrorFillColor": "#FEE6E6",
  "AlertErrorBorderColor": "#C60600",
  "AlertWarningFillColor": "#FFF5E6",
  "AlertWarningBorderColor": "#995C00",
  "AlertBorderWidth": "1",
  "AlertSuccessFillColor": "#E6F9EF",
  "AlertSuccessBorderColor": "#007636",
  "AlertHighlightFillColor": "#f4f3fc",
  "AlertHighlightBorderColor": "#292cb7",
  "AlertTitleTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "AlertMessageTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "AlertPaddingLeft": "16",
  "AlertPaddingRight": "16",
  "AlertPaddingTop": "16",
  "AlertPaddingBottom": "16",
  "AlertBorderRadius": "8",
  "AlertInformativeFillColor": "#f5f5f5",
  "AlertInformativeBorderColor": "#5d5d5d",
  "AlertIconSize": "24px",
  "DropdownSelectContainerHeight": "56px",
  "DropdownSelectContainerIconSize": "24px",
  "DropdownSelectContainerPaddingLeft": "16",
  "DropdownSelectContainerPaddingRight": "16",
  "DropdownSelectContainerActiveFillColor": "#ffffff",
  "DropdownSelectContainerActiveBorderColor": "#747474",
  "DropdownSelectContainerHoverFillColor": "#ffffff",
  "DropdownSelectContainerHoverBorderColor": "#373ae5",
  "DropdownSelectContainerFocusedFillColor": "#ffffff",
  "DropdownSelectContainerFocusedBorderColor": "#292cb7",
  "DropdownSelectContainerPressedFillColor": "#ffffff",
  "DropdownSelectContainerPressedBorderColor": "#373ae5",
  "DropdownSelectContainerDisabledFillColor": "#f5f5f5",
  "DropdownSelectContainerDisabledBorderColor": "#747474",
  "DropdownSelectContainerErrorFillColor": "#ffffff",
  "DropdownSelectContainerErrorBorderColor": "#C60600",
  "DropdownSelectActiveTopBorderRadius": "8",
  "DropdownSelectActiveBottomBorderRadius": "0",
  "DropdownSelectActiveElevation": {
    "x": "0",
    "y": "0",
    "blur": "0",
    "spread": "0",
    "color": "#00000000",
    "type": "innerShadow"
  },
  "DropdownSelectRestinglabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DropdownSelectRestinglabelActiveTextColor": "#747474",
  "DropdownSelectRestinglabelHoverTextColor": "#747474",
  "DropdownSelectRestinglabelFocusedTextColor": "#00012b",
  "DropdownSelectRestinglabelPressedTextColor": "#00012b",
  "DropdownSelectRestinglabelDisabledTextColor": "#747474",
  "DropdownSelectRestinglabelErrorTextColor": "#747474",
  "DropdownSelectFloatinglabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DropdownSelectFloatinglabelActiveTextColor": "#5d5d5d",
  "DropdownSelectFloatinglabelHoverTextColor": "#5d5d5d",
  "DropdownSelectFloatinglabelFocusedTextColor": "#292cb7",
  "DropdownSelectFloatinglabelPressedTextColor": "#373ae5",
  "DropdownSelectFloatinglabelDisabledTextColor": "#747474",
  "DropdownSelectFloatinglabelErrorTextColor": "#C60600",
  "DropdownSelectInputtextTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DropdownSelectHintTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DropdownSelectHintActiveTextColor": "#00012b",
  "DropdownSelectHintErrorTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DropdownSelectHintErrorTextColor": "#C60600",
  "DropdownSelectHintErrorIconSize": "24px",
  "DropdownSelectHintErrorIconColor": "#C60600",
  "DropdownSelectHintHoverTextColor": "#00012b",
  "DropdownSelectHintFocusedTextColor": "#00012b",
  "DropdownSelectHintPressedTextColor": "#00012b",
  "DropdownSelectHintDisabledTextColor": "#747474",
  "DropdownSelectInputTextColor": "#00012b",
  "DropdownSelectIconActiveIconColor": "#00012b",
  "DropdownSelectIconHoverIconColor": "#00012b",
  "DropdownSelectIconFocusedIconColor": "#00012b",
  "DropdownSelectIconPressedIconColor": "#00012b",
  "DropdownSelectIconDisabledIconColor": "#747474",
  "DropdownSelectIconErrorIconColor": "#00012b",
  "DropdownSelectHoverElevation": {
    "x": "0",
    "y": "0",
    "blur": "0",
    "spread": "0",
    "color": "#00000000",
    "type": "innerShadow"
  },
  "DropdownSelectHoverTopBorderRadius": "8",
  "DropdownSelectHoverBottomBorderRadius": "8",
  "DropdownSelectFocusedElevation": {
    "x": "2",
    "y": "2",
    "blur": "8",
    "spread": "0",
    "color": "#373ae51a",
    "type": "dropShadow"
  },
  "DropdownSelectFocusedTopBorderRadius": "8",
  "DropdownSelectFocusedBottomBorderRadius": "8",
  "DropdownSelectPressedElevation": {
    "x": "2",
    "y": "2",
    "blur": "8",
    "spread": "0",
    "color": "#373ae51a",
    "type": "dropShadow"
  },
  "DropdownSelectPressedTopBorderRadius": "8",
  "DropdownSelectPressedBottomBorderRadius": "0",
  "DropdownSelectDisabledElevation": {
    "x": "0",
    "y": "0",
    "blur": "0",
    "spread": "0",
    "color": "#00000000",
    "type": "innerShadow"
  },
  "DropdownSelectDisabledTopBorderRadius": "8",
  "DropdownSelectDisabledBottomBorderRadius": "0",
  "DropdownSelectErrorElevation": {
    "x": "0",
    "y": "0",
    "blur": "0",
    "spread": "0",
    "color": "#00000000",
    "type": "innerShadow"
  },
  "DropdownSelectErrorTopBorderRadius": "8",
  "DropdownSelectErrorBottomBorderRadius": "8",
  "DropdownSelectContainerBorderWidth": "1",
  "DropdownItemTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DropdownItemBorderRadius": "0",
  "DropdownItemActiveFillColor": "#ffffff",
  "DropdownItemActiveTextColor": "#00012b",
  "DropdownItemActiveBorderColor": "#00000000",
  "DropdownItemHoverFillColor": "#f4f3fc",
  "DropdownItemHoverBorderColor": "#00000000",
  "DropdownItemHoverTextColor": "#00012b",
  "DropdownItemPressedFillColor": "#dedefb",
  "DropdownItemPressedBorderColor": "#00000000",
  "DropdownItemPressedTextColor": "#00012b",
  "DropdownItemFocusedFillColor": "#f4f3fc",
  "DropdownItemFocusedBorderColor": "#292cb7",
  "DropdownItemFocusedTextColor": "#00012b",
  "DropdownItemHeight": "48px",
  "DropdownItemDisabledFillColor": "#ffffff",
  "DropdownItemDisabledBorderColor": "#00000000",
  "DropdownItemDisabledTextColor": "#747474",
  "DropdownItemPaddingLeft": "44",
  "DropdownItemPaddingLeftWithIcon": "16",
  "DropdownItemIconSize": "20px",
  "DropdownItemLoadingTextColor": "#747474",
  "DropdownMenuTopBorderRadius": "0",
  "DropdownMenuBottomBorderRadius": "8",
  "DropdownMenuContainerElevation": {
    "x": "2",
    "y": "2",
    "blur": "8",
    "spread": "0",
    "color": "#373ae51a",
    "type": "dropShadow"
  },
  "DropdownMenuFillColor": "#ffffff",
  "DropdownMenuBorderColor": "#00000000",
  "CarouselContainerFillColor": "#00000000",
  "CarouselContainerTextColor": "#00012b",
  "CarouselControlActiveFillColor": "#00000000",
  "CarouselControlActiveBorderColor": "#00012b",
  "CarouselControlActiveIconColor": "#00012b",
  "CarouselControlHoverFillColor": "#00000000",
  "CarouselControlHoverBorderColor": "#00012b",
  "CarouselControlHoverIconColor": "#00012b",
  "CarouselControlFocusedFillColor": "#00000000",
  "CarouselControlFocusedBorderColor": "#00012b",
  "CarouselControlFocusedIconColor": "#00012b",
  "CarouselControlPressedFillColor": "#00012b",
  "CarouselControlPressedBorderColor": "#00012b",
  "CarouselControlPressedIconColor": "#ffffff",
  "CarouselControlDisabledFillColor": "#f5f5f5",
  "CarouselControlDisabledBorderColor": "#a2a2a2",
  "CarouselControlDisabledIconColor": "#a2a2a2",
  "CarouselTitleTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CarouselTitleSmallTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CarouselTitleLargeTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "30",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CarouselElevation": {
    "x": "0",
    "y": "0",
    "blur": "0",
    "spread": "0",
    "color": "#00000000",
    "type": "innerShadow"
  },
  "CarouselWeekCellTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CarouselDayCellNumberTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "18",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "CarouselDayCellCaptionTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ImgCarouselIndicatorActiveFillColor": "#ffffff80",
  "ImgCarouselIndicatorInactiveFillColor": "#ffffff",
  "ImgCarouselIndicatorBorderRadius": "100",
  "ImgCarouselIndicatorHeight": "4",
  "ImgCarouselIndicatorWidth": "32px",
  "ImgCarouselControlsActiveFillColor": "#faf9f5",
  "ImgCarouselControlsActiveBorderColor": "#00012b",
  "ImgCarouselControlsActiveIconColor": "#00012b",
  "ImgCarouselControlsHoverFillColor": "#faf9f5",
  "ImgCarouselControlsHoverBorderColor": "#00012b",
  "ImgCarouselControlsHoverIconColor": "#00012b",
  "ImgCarouselControlsHoverBorderWidth": "2",
  "ImgCarouselControlsFocusedFillColor": "#faf9f5",
  "ImgCarouselControlsFocusedIconColor": "#00012b",
  "ImgCarouselControlsFocusedBorderColor": "#00012b",
  "ImgCarouselControlsPressedFillColor": "#00012b",
  "ImgCarouselControlsPressedBorderColor": "#00012b",
  "ImgCarouselControlsPressedIconColor": "#ffffff",
  "ImgCarouselControlsDisabledFillColor": "#f5f5f5",
  "ImgCarouselControlsDisabledBorderColor": "#a2a2a2",
  "ImgCarouselControlsDisabledIconColor": "#a2a2a2",
  "ImgCarouselControlsDefaultBorderWidth": "1",
  "ImgCarouselControlsFocusselectorBorderColor": "#292cb7",
  "ImgCarouselControlsFocusselectorBorderWidth": "1.5",
  "ImgCarouselControlsFocusselectorLeftControlTopRight": "10",
  "ImgCarouselControlsFocusselectorLeftControlTopLeft": "0",
  "ImgCarouselControlsFocusselectorLeftControlBottomRight": "10",
  "ImgCarouselControlsFocusselectorLeftControlBottomLeft": "0",
  "ImgCarouselControlsFocusselectorRightControlTopRight": "0",
  "ImgCarouselControlsFocusselectorRightControlTopLeft": "10",
  "ImgCarouselControlsFocusselectorRightControlBottomRight": "0",
  "ImgCarouselControlsFocusselectorRightControlBottomLeft": "10",
  "ImgCarouselContainerBorderRadius": "8",
  "ImgCarouselContainerShadowGradient": "linear-gradient(0deg, #000000B3 0%, #0000008C 18%, #5D5D5D26 62%, #5D5D5D00 88%)",
  "ImgCarouselLeftControlTopRight": "8",
  "ImgCarouselLeftControlTopLeft": "0",
  "ImgCarouselLeftControlBottomLeft": "0",
  "ImgCarouselLeftControlBottomRight": "8",
  "ImgCarouselRightControlBottomRight": "0",
  "ImgCarouselRightControlTopRight": "0",
  "ImgCarouselRightControlBottomLeft": "8",
  "ImgCarouselRightControlTopLeft": "8",
  "ImgCarouselControlSize": "40px",
  "AccordionSelectFillColor": "#00000000",
  "AccordionSelectBorderColor": "#00000000",
  "AccordionSelectIconColor": "#00012b",
  "AccordionSelectTextColor": "#00012b",
  "AccordionSelectTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "AccordionSelectPaddingLeft": "16",
  "AccordionSelectPaddingRight": "16",
  "AccordionSelectPaddingTop": "16",
  "AccordionSelectPaddingBottom": "16",
  "AccordionSelectCollapsedTopBorderRadius": "8",
  "AccordionSelectCollapsedBottomBorderRadius": "8",
  "AccordionSelectExpandedTopBorderRadius": "8",
  "AccordionSelectExpandedBottomBorderRadius": "0",
  "AccordionSelectBorderWidth": "1",
  "AccordionContentFillColor": "#00000000",
  "AccordionContentBorderColor": "#00000000",
  "AccordionContentPaddingLeft": "16",
  "AccordionContentPaddingRight": "16",
  "AccordionContentPaddingTop": "0",
  "AccordionContentPaddingBottom": "16",
  "AccordionContentExpandedTopBorderRadius": "0",
  "AccordionContentExpandedBottomBorderRadius": "8",
  "AccordionContentBorderWidth": "1",
  "AccordionFocusselectorBorderColor": "#292cb7",
  "AccordionFocusselectorCollapsedTopBorderRadius": "10",
  "AccordionFocusselectorCollapsedBottomBorderRadius": "10",
  "AccordionFocusselectorExpandedTopBorderRadius": "10",
  "AccordionFocusselectorExpandedBottomBorderRadius": "0",
  "AccordionFocusselectorBorderWidth": "1.5",
  "AccordionIconSize": "24px",
  "ListContainerActiveFillColor": "#00000000",
  "ListContainerActiveBorderColor": "#00000000",
  "ListContainerDisabledFillColor": "#00000000",
  "ListContainerDisabledBorderColor": "#00000000",
  "ListContainerPaddingLeft": "16",
  "ListContainerPaddingRight": "16",
  "ListContainerPaddingTop": "16",
  "ListContainerPaddingBottom": "16",
  "ListTitleActiveTextColor": "#00012b",
  "ListTitleActiveTextColorPositive": "#007636",
  "ListTitleActiveIconColorPositive": "#007636",
  "ListTitleDisabledTextColor": "#747474",
  "ListTitleTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ListBodyActiveTextColor": "#5d5d5d",
  "ListBodyDisabledTextColor": "#747474",
  "ListBodyTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ListIconActiveIconColor": "#00012b",
  "ListIconDisabledIconColor": "#747474",
  "ListMetadataTextColor": "#5d5d5d",
  "ListMetadataTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ListIconSize": "24px",
  "ListTextVerticalPadding": "8",
  "ListButtonActiveFillColor": "#ffffff",
  "ListButtonHoverFillColor": "#f4f3fc",
  "ListButtonFocusedFillColor": "#ffffff",
  "ListButtonPressedFillColor": "#dedefb",
  "ListButtonDisabledFillColor": "#ffffff",
  "ListButtonBorderRadius": "8",
  "CalendarTitleTextColor": "#00012b",
  "CalendarTitleTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "18",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "CalendarNavButtonBorderColor": "#747474",
  "CalendarNavButtonIconColor": "#00012b",
  "CalendarNavButtonFillColor": "#00000000",
  "CalendarNavButtonIconSize": "22px",
  "CalendarNavButtonSize": "32px",
  "CalendarNavButtonBorderRadius": "4",
  "CalendarWeekCellTextColor": "#747474",
  "CalendarWeekCellTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CalendarDayCellIndicatorFillColorActive": "#00012b",
  "CalendarDayCellIndicatorFillColorHover": "#00012b",
  "CalendarDayCellIndicatorFillColorSelected": "#ffffff",
  "CalendarDayCellIndicatorFillColorDisabled": "#a2a2a2",
  "CalendarDayCellIndicatorFillColorUnavailable": "#747474",
  "CalendarDayCellIndicatorFillColorError": "#ffffff",
  "CalendarDayCellIndicatorSize": "6",
  "CalendarDayCellIndicatorRangeMiddleFillColorError": "#00012b",
  "CalendarDayCellIndicatorNoOfferFillColor": "#171717",
  "CalendarDayCellIndicatorLowestPriceFillColor": "#007636",
  "CalendarDayCellNumberTextColorActive": "#00012b",
  "CalendarDayCellNumberTextColorHover": "#00012b",
  "CalendarDayCellNumberTextColorSelected": "#ffffff",
  "CalendarDayCellNumberTextColorDisabled": "#a2a2a2",
  "CalendarDayCellNumberTextColorUnavailable": "#747474",
  "CalendarDayCellNumberTextColorError": "#ffffff",
  "CalendarDayCellNumberTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CalendarDayCellNumberRangeMiddleTextColorError": "#00012b",
  "CalendarDayCellCaptionTextColorActive": "#5d5d5d",
  "CalendarDayCellCaptionTextColorActiveOffer": "#171717",
  "CalendarDayCellCaptionTextColorActiveLowestPrice": "#007636",
  "CalendarDayCellCaptionTextColorHover": "#5d5d5d",
  "CalendarDayCellCaptionTextColorSelected": "#ffffff",
  "CalendarDayCellCaptionTextColorDisabled": "#a2a2a2",
  "CalendarDayCellCaptionTextColorUnavailable": "#747474",
  "CalendarDayCellCaptionTextColorError": "#ffffff",
  "CalendarDayCellCaptionTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CalendarDayCellCaptionRangeMiddleTextColorError": "#5d5d5d",
  "CalendarDayCellCaptionOfferText": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "fontSize": "12",
    "lineHeight": "100%",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "CalendarDayCellCellColorActive": "#00000000",
  "CalendarDayCellCellColorHover": "#dedefb",
  "CalendarDayCellCellColorSelected": "#373ae5",
  "CalendarDayCellCellColorDisabled": "#00000000",
  "CalendarDayCellCellColorUnavailable": "#00000000",
  "CalendarDayCellCellColorError": "#C60600",
  "CalendarDayCellWidth": "48px",
  "CalendarDayCellHeight": "56px",
  "CalendarDayCellBorderRadius": "8",
  "CalendarDayCellFocusIndicatorBorderColor": {
    "color": "#292cb7",
    "width": "1",
    "style": "solid"
  },
  "CalendarDayCellRangeMiddleCellColorError": "#FDCECC",
  "CalendarDayCellIndicatorNoOfferSize": "12",
  "CalendarDayCellIndicatorLowestPriceSize": "12",
  "CalendarDisabledOpacity": "50%",
  "ModalOverlayFillColor": "#00000066",
  "ModalFillColor": "#faf9f5",
  "ModalTitleTextColor": "#00012b",
  "ModalTitleTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ModalTitleTextSizeCopy": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "ModalIconColor": "#00012b",
  "ModalBorderRadius": "16",
  "ModalIconSize": "32px",
  "ModalOverflowTop": {
    "x": "0",
    "y": "3",
    "blur": "8",
    "spread": "0",
    "color": "#0000001a",
    "type": "dropShadow"
  },
  "ModalOverflowBottom": {
    "x": "0",
    "y": "-3",
    "blur": "8",
    "spread": "0",
    "color": "#0000001a",
    "type": "dropShadow"
  },
  "ModalMobileFullScreenBorderRadius": "0",
  "StepInprogressTextColor": "#00012b",
  "StepInprogressIconColor": "#373ae5",
  "StepCompleteTextColor": "#00012b",
  "StepCompleteIconColor": "#007636",
  "StepErrorTextColor": "#00012b",
  "StepErrorIconColor": "#C60600",
  "StepDisabledTextColor": "#747474",
  "StepDisabledIconColor": "#747474",
  "StepDisabledTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "StepStepHeight": "24px",
  "StepActiveTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "StepHoverTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "StepFocusedTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "StepSelectedTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "StepFocusselectorBorderRadius": "8",
  "StepFocusselectorBorderWdith": "1.5",
  "StepFocusselectorBorderColor": "#292cb7",
  "SnackbarFillColor": "#171717",
  "SnackbarTextColor": "#ffffff",
  "SnackbarActionHeight": "40px",
  "SnackbarActionTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "SnackbarMessageTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "SnackbarBorderRadius": "8",
  "SnackbarMaxWidth": "480",
  "DrawerOverlayFillColor": "#00000066",
  "DrawerFillColor": "#faf9f5",
  "DrawerTitleTextColor": "#00012b",
  "DrawerTitleTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DrawerIconColor": "#00012b",
  "DrawerIconSize": "32px",
  "DrawerWidth": "375",
  "DrawerBorderRadius": "0",
  "TabsDividerBorderColor": "#d1d1d1",
  "TabsLabelUnselectedTextColor": "#00012b",
  "TabsLabelSelectedHoverTextColor": "#373ae5",
  "TabsLabelDisabledTextColor": "#a2a2a2",
  "TabsLabelDefaultTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TabsLabelSelectedTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TabsIndicatorFillColor": "#373ae5",
  "TabsHeight": "56px",
  "TabsPaddingLeftRight": "16",
  "TabsFocusselectorBorderColor": "#292cb7",
  "TabsFocusselectorBorderRadius": "4",
  "TabsFocusselectorBorderWidth": "1.5",
  "TagPrimaryFillColor": "#292cb7",
  "TagPrimaryTextColor": "#ffffff",
  "TagPrimaryLContainerHeight": "32px",
  "TagPrimarySContainerHeight": "24px",
  "TagPrimaryTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TagPrimaryPaddingRight": "8",
  "TagPrimaryPaddingLeft": "8",
  "TagPrimaryTopLeftBorderRadius": "0",
  "TagPrimaryBottomLeftBorderRadius": "0",
  "TagPrimaryTopRightBorderRadius": "4",
  "TagPrimaryBottomRightBorderRadius": "4",
  "TagPrimaryStandaloneBorderRadius": "4",
  "TagSecondaryPositiveIconColor": "#007636",
  "TagSecondaryPositiveTextColor": "#007636",
  "TagSecondaryWarningIconColor": "#995C00",
  "TagSecondaryWarningTextColor": "#995C00",
  "TagSecondaryNegativeIconColor": "#C60600",
  "TagSecondaryNegativeTextColor": "#C60600",
  "TagSecondaryNeutralIconColor": "#00012b",
  "TagSecondaryNeutralTextColor": "#00012b",
  "TagSecondaryIconSize": "18px",
  "TagSecondaryTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TagSecondaryBackgroundColor": "#ffffff",
  "TagSecondaryBackgroundContainerHeight": "24px",
  "TagSecondaryBackgroundPaddingRight": "8",
  "TagSecondaryBackgroundPaddingLeft": "8",
  "TagSecondaryBackgroundBorderRadius": "4",
  "TagLContainerHeight": "32px",
  "TagLIconSize": "18px",
  "TagSContainerHeight": "24px",
  "TagTertiaryFillColor": "#f5f5f5",
  "TagTertiaryTextColor": "#5d5d5d",
  "TagTertiaryTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TagTertiaryPaddingLeft": "8",
  "TagTertiaryPaddingRight": "8",
  "TagTertiaryBorderRadius": "4",
  "TagItemSpacing": "4",
  "DatePickerPlaceholderTextColor": "#a2a2a2",
  "DatePickerPlaceholderTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DatePickerCalendarCellDefaultFillColor": "#00000000",
  "DatePickerCalendarCellDefaultTextColor": "#00012b",
  "DatePickerCalendarCellSelectedPrimaryFillColor": "#373ae5",
  "DatePickerCalendarCellSelectedPrimaryTextColor": "#ffffff",
  "DatePickerCalendarCellSelectedPrimaryBorderRadius": "8",
  "DatePickerCalendarCellSelectedSecondaryFillColor": "interaction.muted",
  "DatePickerCalendarCellSelectedSecondaryTextColor": "fg.default",
  "DatePickerCalendarHeadingBackgroundColor": "#faf9f5",
  "DatePickerCalendarHeadingTextColor": "#00012b",
  "DatePickerCalendarHeadingBorderColor": "#d1d1d1",
  "DatePickerCalendarHeadingBorderWidth": "1",
  "DatePickerCalendarHeadingLabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DatePickerCalendarHeadingTitleTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "DateRangeStartFieldDefaultTopRight": "0",
  "DateRangeStartFieldDefaultTopLeft": "8",
  "DateRangeStartFieldDefaultBottomRight": "0",
  "DateRangeStartFieldDefaultBottomLeft": "0",
  "DateRangeStartFieldFocusedTopRight": "0",
  "DateRangeStartFieldFocusedTopLeft": "8",
  "DateRangeStartFieldFocusedBottomRight": "0",
  "DateRangeStartFieldFocusedBottomLeft": "8",
  "DateRangeEndFieldDefaultTopRight": "8",
  "DateRangeEndFieldDefaultTopLeft": "0",
  "DateRangeEndFieldDefaultBottomRight": "0",
  "DateRangeEndFieldDefaultBottomLeft": "0",
  "DateRangeEndFieldFocusedTopRight": "8",
  "DateRangeEndFieldFocusedTopLeft": "0",
  "DateRangeEndFieldFocusedBottomRight": "8",
  "DateRangeEndFieldFocusedBottomLeft": "0",
  "DateRangeDividerBorderColor": "#d1d1d1",
  "DateRangeDividerSize": "32px",
  "DateRangeDividerBorderWidth": "1",
  "DateRangeDefaultBorderRadius": "8",
  "DateRangeFocusedBorderRadius": "8",
  "DateRangeErrorBorderRadius": "8",
  "DateRangeButtonDefaultIconColor": "#00012b",
  "DateRangeButtonInteractiveIconColor": "#373ae5",
  "CardTitleTextColor": "#00012b",
  "CardTitleTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "18",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "CardBodyTextColor": "#00012b",
  "CardBodyDefaultTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CardBodySmallTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CardMetadataTextColor": "#5d5d5d",
  "CardMetadataTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "135%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "CardContainerPadding": "16",
  "CardContentItemSpacing": "4",
  "CardTagRowItemSpacing": "8",
  "CardTagRowPaddingTop": "8",
  "CardActionRowItemSpacing": "8",
  "CardActionRowPaddingTop": "16",
  "CardPriceAreaPaddingTop": "16",
  "CardPriceTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "135%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TimerFillColor": "#ffffff",
  "TimerExpiringFillColor": "#C60600",
  "TimerBorderColor": "#00000000",
  "TimerTrackFillColor": "#d1d1d1",
  "TimerTrackBorderColor": "#00000000",
  "TimerTrackHeight": "2",
  "TimerTrackWidth": "8px",
  "TimerTrackBorderRadius": "0",
  "TimerTrackBorderWidth": "1",
  "TimerIndicatorBorderColor": "#00000000",
  "TimerIndicatorMaxTimeFillColor": "#007636",
  "TimerIndicatorTwoThirdsFillColor": "#995C00",
  "TimerIndicatorOneThirdFillColor": "#C60600",
  "TimerIndicatorExpiringFillColor": "#C60600",
  "TimerIndicatorHeight": "2",
  "TimerIndicatorWidth": "8px",
  "TimerIndicatorBorderRadius": "0",
  "TimerIndicatorBorderWidth": "1",
  "TimerLabelMaxTimeTextColor": "#007636",
  "TimerLabelTwoThirdsTextColor": "#995C00",
  "TimerLabelOneThirdTextColor": "#C60600",
  "TimerLabelExpiringTextColor": "#ffffff",
  "TimerLabelTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "14",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TimerLabelVerticalPadding": "8",
  "TimerLabelHorizontalSpacing": "4",
  "TimerBorderRadius": "0",
  "TimerBorderWidth": "1",
  "TimerHeight": "37",
  "DividerBorderColor": "#d1d1d1",
  "DividerBorderRadius": "100",
  "DividerBorderWidth": "1",
  "RangeCalendarInputVerticalPadding": "16",
  "IconButtonDefaultActiveIconColor": "#00012b",
  "IconButtonDefaultActiveFillOpacity": "0%",
  "IconButtonDefaultHoverIconColor": "#00012b",
  "IconButtonDefaultHoverFillColor": "#00012b",
  "IconButtonDefaultHoverFillOpacity": "10%",
  "IconButtonDefaultPressedIconColor": "#00012b",
  "IconButtonDefaultPressedFillColor": "#00012b",
  "IconButtonDefaultPressedFillOpacity": "20%",
  "IconButtonDefaultDisabledIconColor": "#a2a2a2",
  "IconButtonDefaultDisabledFillOpacity": "0%",
  "IconButtonOutlinedActiveBorderColor": "#5d5d5d",
  "IconButtonOutlinedActiveIconColor": "#00012b",
  "IconButtonOutlinedActiveBorderWidth": "1",
  "IconButtonOutlinedHoverBorderColor": "#00012b",
  "IconButtonOutlinedHoverIconColor": "#00012b",
  "IconButtonOutlinedHoverBorderWidth": "2",
  "IconButtonOutlinedPressedFillColor": "#00012b",
  "IconButtonOutlinedPressedIconColor": "#ffffff",
  "IconButtonOutlinedDisabledBorderColor": "#a2a2a2",
  "IconButtonOutlinedDisabledIconColor": "#a2a2a2",
  "IconButtonFilledActiveFillColor": "#faf9f5",
  "IconButtonFilledActiveIconColor": "#00012b",
  "IconButtonFilledActiveFillOpacity": "60%",
  "IconButtonFilledActiveBorderColor": "#d1d1d1",
  "IconButtonFilledActiveBorderWidth": "1",
  "IconButtonFilledHoverFillColor": "#faf9f5",
  "IconButtonFilledHoverIconColor": "#00012b",
  "IconButtonFilledHoverFillOpacity": "80%",
  "IconButtonFilledHoverBorderColor": "#d1d1d1",
  "IconButtonFilledHoverBorderWidth": "2",
  "IconButtonFilledPressedFillColor": "#faf9f5",
  "IconButtonFilledPressedIconColor": "#00012b",
  "IconButtonFilledPressedFillOpacity": "90%",
  "IconButtonFilledPressedBorderColor": "#d1d1d1",
  "IconButtonFilledDisabledFillColor": "#faf9f5",
  "IconButtonFilledDisabledIconColor": "#747474",
  "IconButtonFilledDisabledBorderColor": "#d1d1d1",
  "IconButtonFilledDisabledFillOpacity": "50%",
  "IconButtonLHeight": "40px",
  "IconButtonLIconSize": "24px",
  "IconButtonSHeight": "32px",
  "IconButtonSIconSize": "20px",
  "IconButtonFocusselectorBorderColor": "#292cb7",
  "IconButtonFocusselectorBorderWidth": "1.5",
  "IconButtonFocusselectorBorderRadius": "4",
  "IconButtonFillActiveBorderWidth": "1",
  "TextareaSHeight": "96",
  "TextareaMHeight": "144",
  "TextareaLHeight": "192",
  "TextareaXsHeight": "56px",
  "SidebarOverlayFillColor": "#00000066",
  "SidebarFillColor": "#faf9f5",
  "SidebarIconColor": "#ffffff",
  "SidebarWidth": "375",
  "SidebarIconSize": "24px",
  "AvatarActiveFillColor": "linear-gradient(206deg, #373ae5 0%, #292cb7 52.08%)",
  "AvatarActiveIconColor": "#ffffff",
  "AvatarActiveBorderColor": "#ffffff",
  "AvatarActiveBadgeColor": "#C60600",
  "AvatarHoverFillColor": "#373ae5",
  "AvatarHoverIconColor": "#ffffff",
  "AvatarHoverBorderColor": "#ffffff",
  "AvatarHoverBadgeColor": "#C60600",
  "AvatarFocusedFillColor": "#373ae5",
  "AvatarFocusedIconColor": "#ffffff",
  "AvatarFocusedBorderColor": "#ffffff",
  "AvatarFocusedBadgeColor": "#C60600",
  "AvatarPressedFillColor": "#1b1d88",
  "AvatarPressedIconColor": "#ffffff",
  "AvatarPressedBorderColor": "#ffffff",
  "AvatarPressedBadgeColor": "#C60600",
  "AvatarDisabledFillColor": "#747474",
  "AvatarDisabledIconColor": "#ffffff",
  "AvatarDisabledBorderColor": "#ffffff",
  "AvatarDisabledBadgeColor": "#C60600",
  "AvatarLHeight": "40px",
  "AvatarLTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "AvatarLIconSize": "24px",
  "AvatarMHeight": "32px",
  "AvatarMTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "AvatarMIconSize": "20px",
  "AvatarSHeight": "24px",
  "AvatarSTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "12",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "AvatarSIconSize": "16px",
  "AvatarBorderWidth": "1",
  "AvatarFocusselectorBorderColor": "#292cb7",
  "AvatarFocusselectorBorderWidth": "1.5",
  "AvatarImageAspectRatio": "1",
  "AvatarBadgeLSize": "10",
  "AvatarBadgeMSize": "8",
  "AvatarBadgeSSize": "6",
  "AvatarBadgeBorderWidth": "1",
  "AvatarBadgeTopSpacing": "1",
  "AvatarBadgeRightSpacing": "1",
  "TableCellFillColor": "#00000000",
  "TableCellBottomBorderColor": "#d1d1d1",
  "TableCellActiveTextColor": "#00012b",
  "TableCellDisabledTextColor": "#a2a2a2",
  "TableCellTitleActiveFillColor": "#00000000",
  "TableCellTitleActiveTextColor": "#00012b",
  "TableCellTitleActiveIconColor": "#00012b",
  "TableCellTitlePressedFillColor": "#f4f3fc",
  "TableCellTitleHoverFillColor": "#dedefb",
  "TableCellTitleDisabledTextColor": "#a2a2a2",
  "TableCellTitleDisabledIconColor": "#a2a2a2",
  "TableCellTitleIconSize": "24px",
  "TableCellTitleTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "TableCellBorderRadius": "0",
  "TableCellBottomBorderWidth": "1",
  "TableCellHeight": "48px",
  "TableCellPadding": "8",
  "TableCellTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Regular",
    "lineHeight": "100%",
    "fontSize": "16",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "underline",
    "textCase": "none"
  },
  "TableCellFocusselectorBorderColor": "#292cb7",
  "TableCellFocusselectorBorderWidth": "1.5",
  "TableCellFocusselectorBorderRadius": "6",
  "BadgeDefaultFillColor": "#00012b",
  "BadgeHighlightFillColor": "#292cb7",
  "BadgeWarningFillColor": "#C60600",
  "BadgeTextColor": "#ffffff",
  "BadgeBorderColor": "#faf9f5",
  "BadgeLargeTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "fontSize": "8",
    "lineHeight": "100%",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textDecoration": "none",
    "textCase": "none"
  },
  "BadgeLargeSize": "10",
  "BadgeMediumSize": "8px",
  "BadgeSmallSize": "6",
  "BadgeTopSpacing": "1",
  "BadgeRightSpacing": "1",
  "BadgeBorderRadius": "100",
  "BadgeBorderWidth": "1",
  "PaginationTextColor": "#5d5d5d",
  "PaginationIndicatorFillColor": "#00012b",
  "PaginationTrackFillColor": "#d1d1d1",
  "StepperActiveTextColor": "#00012b",
  "StepperHoverTextColor": "#00012b",
  "StepperFocusedTextColor": "#00012b",
  "StepperPressedTextColor": "#00012b",
  "StepperDisabledTextColor": "#747474",
  "StepperTextSize": {
    "fontFamily": "Calibre-R",
    "fontWeight": "Medium",
    "lineHeight": "100%",
    "fontSize": "20",
    "letterSpacing": "0%",
    "paragraphSpacing": "0%",
    "textCase": "none",
    "textDecoration": "none"
  },
  "StepperControlGap": "16",
  "IconFillColor": "#00012b",
  "EventlistItemHoverBackgroundColor": "#f8f4ec",
  "EventlistItemPressedBackgroundColor": "#f6eddd"
}